/* oxlint-disable */
'use client';

import {
  memo, useEffect, useState,
} from 'react';

import { LoopVideoProps } from '@/features/v2/shared/Header/interfaces';
import '../styles.css';

const LoopVideo = memo(({ images = [] }: LoopVideoProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <div className="relative w-full md:w-4/6">
      <div
        className="relative z-0 -mb-10 w-auto h-auto bg-transparent maskMd md:!h-96 md:!max-h-96 mask overflow-hidden"
        style={{
          maxHeight: '400px',
          width: '100%',
          height: '400px',
          backgroundColor: 'transparent',
        }}
      >
        {images.map((img, i) => (
          <img
            key={img.src}
            src={img.src}
            alt="banner"
            className={`
              absolute inset-0 w-full h-full object-cover
              ${img.position || 'object-center'}
              transition-opacity duration-700
              ${i === index ? 'opacity-100' : 'opacity-0'}
              pointer-events-none
            `}
          />
        ))}
      </div>

      <div className="fade-bottom" />
      <div className="fade-left" />
    </div>
  );
});

export default LoopVideo;